import React from "react";
import Lozenge from "@atlaskit/lozenge";
import Button from "@atlaskit/button";
import ArrowUpIcon from "@atlaskit/icon/glyph/arrow-up";
import ArrowDownIcon from "@atlaskit/icon/glyph/arrow-down";
import { Checkbox } from "@atlaskit/checkbox";
//import { formatDateJobLog } from "../../../helpers/helpers";
import moment from "moment";
import Epic16Icon from "@atlaskit/icon-object/glyph/epic/16";
import Task16Icon from "@atlaskit/icon-object/glyph/task/16";
import Subtask16Icon from "@atlaskit/icon-object/glyph/subtask/16";
import Skeleton from "react-loading-skeleton";
import styles from "./Wrapper.module.css";
import Avatar from "@atlaskit/avatar";

export const TableWrapper = ({ children }) => (
  <div className={styles.tableWrapperStyles}>{children}</div>
);

export const NameWrapper = ({ children }) => (
  <span className={styles.nameWrapperStyles}>{children}</span>
);

export const AvatarWrapper = ({ children }) => (
  <div className={styles.avatarWrapperStyles}>{children}</div>
);

export const createHead = (
  withWidth,
  sortFlags,
  handleCheckboxCheckAll,
  handleSorting,
  isLoading,
  globalCheckState
) => {
  return {
    cells: [
      {
        content: (
          <Checkbox
            isDisabled={globalCheckState.disabled || isLoading}
            isChecked={globalCheckState.allChecked}
            isIndeterminate={globalCheckState.indeterminate}
            value="All"
            name="parent"
            type="checkbox"
            onChange={(e) => handleCheckboxCheckAll(e)}
          />
        ),
        key: "selectRow",
        isSortable: false,
        width: withWidth ? 15 : undefined,
      },
      {
        content: <p style={{ marginTop: "5px" }}>Id</p>,
        key: "Id",
        isSortable: false,
        width: withWidth ? 15 : undefined,
      },
      {
        content: (
          <Button
            style={
              sortFlags.projectSortFlag === 0
                ? { backgroundColor: "#fff" }
                : { backgroundColor: "#f5f5f5" }
            }
            iconAfter={
              sortFlags.projectSortFlag === 0 ? (
                ""
              ) : sortFlags.projectSortFlag === 1 ? (
                <ArrowUpIcon size="small" />
              ) : sortFlags.projectSortFlag === 2 ? (
                <ArrowDownIcon size="small" />
              ) : (
                ""
              )
            }
            onClick={() =>
              handleSorting(
                "project",
                sortFlags.projectSortFlag === 0
                  ? "asc"
                  : sortFlags.projectSortFlag === 1
                  ? "desc"
                  : sortFlags.projectSortFlag === 2
                  ? "asc"
                  : ""
              )
            }
          >
            Project
          </Button>
        ),
        key: "project",
        isSortable: false,
        width: withWidth ? 120 : undefined,
      },
      {
        content: (
          <Button
            style={
              sortFlags.keySortFlag === 0
                ? { backgroundColor: "#fff" }
                : { backgroundColor: "#f5f5f5" }
            }
            iconAfter={
              sortFlags.keySortFlag === 0 ? (
                ""
              ) : sortFlags.keySortFlag === 1 ? (
                <ArrowUpIcon size="small" />
              ) : sortFlags.keySortFlag === 2 ? (
                <ArrowDownIcon size="small" />
              ) : (
                ""
              )
            }
            onClick={() =>
              handleSorting(
                "jira_key",
                sortFlags.keySortFlag === 0
                  ? "asc"
                  : sortFlags.keySortFlag === 1
                  ? "desc"
                  : sortFlags.keySortFlag === 2
                  ? ""
                  : ""
              )
            }
          >
            Key
          </Button>
        ),
        key: "key1",
        isSortable: false,
        width: withWidth ? 40 : undefined,
      },
      {
        content: (
          <Button
            style={
              sortFlags.issueTypeSortFlag === 0
                ? { backgroundColor: "#fff" }
                : { backgroundColor: "#f5f5f5" }
            }
            iconAfter={
              sortFlags.issueTypeSortFlag === 0 ? (
                ""
              ) : sortFlags.issueTypeSortFlag === 1 ? (
                <ArrowUpIcon size="small" />
              ) : sortFlags.issueTypeSortFlag === 2 ? (
                <ArrowDownIcon size="small" />
              ) : (
                ""
              )
            }
            onClick={() =>
              handleSorting(
                "issue_type",
                sortFlags.issueTypeSortFlag === 0
                  ? "asc"
                  : sortFlags.issueTypeSortFlag === 1
                  ? "desc"
                  : sortFlags.issueTypeSortFlag === 2
                  ? ""
                  : ""
              )
            }
          >
            Issue Type
          </Button>
        ),
        key: "issueType",
        isSortable: false,
        width: withWidth ? 40 : undefined,
      },
      // {
      //   content: (
      //     <Button
      //       style={
      //         sortFlags.summarySortFlag === 0
      //           ? { backgroundColor: "#fff" }
      //           : { backgroundColor: "#f5f5f5" }
      //       }
      //       iconAfter={
      //         sortFlags.summarySortFlag === 0 ? (
      //           ""
      //         ) : sortFlags.summarySortFlag === 1 ? (
      //           <ArrowUpIcon size="small" />
      //         ) : sortFlags.summarySortFlag === 2 ? (
      //           <ArrowDownIcon size="small" />
      //         ) : (
      //           ""
      //         )
      //       }
      //       onClick={() =>
      //         handleSorting(
      //           "summary",
      //           sortFlags.summarySortFlag === 0
      //             ? "asc"
      //             : sortFlags.summarySortFlag === 1
      //             ? "desc"
      //             : sortFlags.summarySortFlag === 2
      //             ? "asc"
      //             : ""
      //         )
      //       }
      //     >
      //       Summary
      //     </Button>
      //   ),
      //   key: "summary",
      //   isSortable: false,
      //   width: withWidth ? 100 : undefined,
      // },
      {
        content: (
          <Button
            style={
              sortFlags.eventTypeSortFlag === 0
                ? { backgroundColor: "#fff" }
                : { backgroundColor: "#f5f5f5" }
            }
            iconAfter={
              sortFlags.eventTypeSortFlag === 0 ? (
                ""
              ) : sortFlags.eventTypeSortFlag === 1 ? (
                <ArrowUpIcon size="small" />
              ) : sortFlags.eventTypeSortFlag === 2 ? (
                <ArrowDownIcon size="small" />
              ) : (
                ""
              )
            }
            onClick={() =>
              handleSorting(
                "event_type",
                sortFlags.eventTypeSortFlag === 0
                  ? "asc"
                  : sortFlags.eventTypeSortFlag === 1
                  ? "desc"
                  : sortFlags.eventTypeSortFlag === 2
                  ? "asc"
                  : ""
              )
            }
          >
            Event Type
          </Button>
        ),
        key: "eventType",
        isSortable: false,
        width: withWidth ? 100 : undefined,
      },
      {
        content: (
          <Button
            style={
              sortFlags.eventDateSortFlag === 0
                ? { backgroundColor: "#fff" }
                : { backgroundColor: "#f5f5f5" }
            }
            iconAfter={
              sortFlags.eventDateSortFlag === 0 ? (
                ""
              ) : sortFlags.eventDateSortFlag === 1 ? (
                <ArrowUpIcon size="small" />
              ) : sortFlags.eventDateSortFlag === 2 ? (
                <ArrowDownIcon size="small" />
              ) : (
                ""
              )
            }
            onClick={() =>
              handleSorting(
                "date",
                sortFlags.eventDateSortFlag === 0
                  ? "asc"
                  : sortFlags.eventDateSortFlag === 1
                  ? "desc"
                  : sortFlags.eventDateSortFlag === 2
                  ? "asc"
                  : ""
              )
            }
          >
            Event Date (UTC)
          </Button>
        ),
        key: "eventDate",
        isSortable: false,
        width: withWidth ? 80 : undefined,
      },
      {
        content: (
          <Button
            style={
              sortFlags.initiatorSortFlag === 0
                ? { backgroundColor: "#fff" }
                : { backgroundColor: "#f5f5f5" }
            }
            iconAfter={
              sortFlags.initiatorSortFlag === 0 ? (
                ""
              ) : sortFlags.initiatorSortFlag === 1 ? (
                <ArrowUpIcon size="small" />
              ) : sortFlags.initiatorSortFlag === 2 ? (
                <ArrowDownIcon size="small" />
              ) : (
                ""
              )
            }
            onClick={() =>
              handleSorting(
                "user",
                sortFlags.initiatorSortFlag === 0
                  ? "asc"
                  : sortFlags.initiatorSortFlag === 1
                  ? "desc"
                  : sortFlags.initiatorSortFlag === 2
                  ? "asc"
                  : ""
              )
            }
          >
            Initiator
          </Button>
        ),
        key: "initiator",
        isSortable: false,
        width: withWidth ? 70 : undefined,
      },
      // {
      //   content: (
      //     <Button
      //       style={
      //         sortFlags.assigneeSortFlag === 0
      //           ? { backgroundColor: "#fff" }
      //           : { backgroundColor: "#f5f5f5" }
      //       }
      //       iconAfter={
      //         sortFlags.assigneeSortFlag === 0 ? (
      //           ""
      //         ) : sortFlags.assigneeSortFlag === 1 ? (
      //           <ArrowUpIcon size="small" />
      //         ) : sortFlags.assigneeSortFlag === 2 ? (
      //           <ArrowDownIcon size="small" />
      //         ) : (
      //           ""
      //         )
      //       }
      //       onClick={() =>
      //         handleSorting(
      //           "assignee",
      //           sortFlags.assigneeSortFlag === 0
      //             ? "asc"
      //             : sortFlags.assigneeSortFlag === 1
      //             ? "desc"
      //             : sortFlags.assigneeSortFlag === 2
      //             ? "asc"
      //             : ""
      //         )
      //       }
      //     >
      //       Assignee
      //     </Button>
      //   ),
      //   key: "assignee",
      //   isSortable: false,
      //   width: withWidth ? 70 : undefined,
      // },
      // {
      //   content: (
      //     <Button
      //       style={
      //         sortFlags.reporterSortFlag === 0
      //           ? { backgroundColor: "#fff" }
      //           : { backgroundColor: "#f5f5f5" }
      //       }
      //       iconAfter={
      //         sortFlags.reporterSortFlag === 0 ? (
      //           ""
      //         ) : sortFlags.reporterSortFlag === 1 ? (
      //           <ArrowUpIcon size="small" />
      //         ) : sortFlags.reporterSortFlag === 2 ? (
      //           <ArrowDownIcon size="small" />
      //         ) : (
      //           ""
      //         )
      //       }
      //       onClick={() =>
      //         handleSorting(
      //           "reporter",
      //           sortFlags.reporterSortFlag === 0
      //             ? "asc"
      //             : sortFlags.reporterSortFlag === 1
      //             ? "desc"
      //             : sortFlags.reporterSortFlag === 2
      //             ? "asc"
      //             : ""
      //         )
      //       }
      //     >
      //       Reporter
      //     </Button>
      //   ),
      //   key: "reporter",
      //   isSortable: false,
      //   width: withWidth ? 70 : undefined,
      // },
    ],
  };
};

// function formatDate(dt) {
//   const newDt = moment(dt).utc().format("LLLL");
//   return `${newDt} UTC`;
// }

function createKey(input) {
  return input ? input.replace(/^(the|a|an)/, "").replace(/\s/g, "") : input;
}

function eventTypeBackColor(eventType) {
  switch (eventType.toLowerCase()) {
    case "jira:issue_created":
      return "rgb(227, 252, 239)";
    case "jira:issue_updated":
      return "rgb(222, 235, 255)";
    case "jira:issue_deleted":
      return "rgb(255, 235, 230)";
    default:
      return "rgb(235, 236, 240)";
  }
}

export const createCells = (
  deletedIssues,
  handleCheckboxCheck,
  tempCheckedItems,
  checkedIssues
) =>
  deletedIssues.map((data, index) => ({
    key: `row-${index}-${data.id}`,
    cells: [
      {
        key: createKey("selectRow"),
        content: (
          <Checkbox
            key={data.id}
            isDisabled={
              tempCheckedItems[data.id] !== true && checkedIssues.length > 49
                ? true
                : false
            }
            isChecked={
              tempCheckedItems !== [] ? tempCheckedItems[data.id] : false
            }
            name={data.id}
            onChange={(e) => {
              handleCheckboxCheck(e, data);
            }}
          />
        ),
      },
      {
        key: createKey(data.id.toString()),
        content: data.id,
      },
      {
        key: createKey(data.project),
        content: (
          <NameWrapper>
            <AvatarWrapper>
              <img
                className={styles.avatar}
                src={data.projectImageUrl}
                width="32px"
                height="32px"
                alt="Project Avatar"
              ></img>
            </AvatarWrapper>
            {data.project}
          </NameWrapper>
        ),
      },
      {
        key: createKey(data.jiraKey),
        content: data.jiraKey,
      },
      {
        key: createKey("issueType"),
        content: data.issueType,
      },
      // {
      //   key: createKey(data.summary),
      //   content: data.summary,
      // },
      {
        key: createKey(data.eventType),
        content: (
          <Lozenge
            style={{
              backgroundColor: eventTypeBackColor(data.eventType),
              color: "#000",
            }}
            isBold
          >
            {data.eventType}
          </Lozenge>
        ),
      },
      {
        key: createKey("date"),
        //content: formatDateJobLog(data.date),
        content: moment.utc(data.date).format("llll"),
      },
      {
        key: createKey(data.userName),
        content:
          data.userName === "Not found" ? (
            data.initiatorAccountId
          ) : (
            <NameWrapper>
              <AvatarWrapper>
                <Avatar src={data.avatar} name={"Username"} size="small" />
              </AvatarWrapper>
              {data.userName === "-" ? (
                <Skeleton
                  width={"150px"}
                  count={1}
                  baseColor="lightgrey"
                  height={"10px"}
                />
              ) : (
                data.userName
              )}
            </NameWrapper>
          ),
      },
      // {
      //   key: createKey(data.assignee),
      //   content: "-",
      // },
      // {
      //   key: createKey(data.reporter),
      //   content: "-",
      // },
    ],
  }));
